'use client'

import { useEffect, useRef, useState } from 'react'

import { LottieAnimation } from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface FailedTransactionProps {
  onCountdownComplete: () => void
}

export function FailedTransaction({ onCountdownComplete }: FailedTransactionProps) {
  const [count, setCount] = useState(5)
  const onCompleteRef = useRef(onCountdownComplete)
  onCompleteRef.current = onCountdownComplete

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          onCompleteRef.current()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className='srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-4 srd:px-2'>
      <LottieAnimation
        animationConfig={{
          path: getStaticAssetUrl('lottie/x-animation-lottiefiles.json'),
          loop: false,
          autoplay: true,
        }}
        style={{
          width: '100%',
          maxWidth: 'calc(var(--spacing) * 50)',
          height: 'fit-content',
        }}
      />

      <p className={cn(typographyVariants({ variant: 'headline-sm' }), 'srd:text-neutral-black srd:text-center')}>
        Transaksi gagal
      </p>

      <p className={cn(typographyVariants({ variant: 'body-sm' }), 'srd:text-grey-100 srd:text-center')}>
        Mengalihkan anda kembali ke pengaturan dalam {count} detik...
      </p>
    </div>
  )
}
